import { useCallback, useEffect, useState } from 'react'
import Card from 'shared/Cards/Card'
import TextField from 'shared/Forms/TextField'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import http from 'services/http'
import inspectionApi from '../../../../inspection.api'
import { CheckResultArtefact } from '../../../../inspection.types'

const SubmissionTeamAnswersCard = ({ resultId }: { resultId: string | undefined }) => {
  const [items, setItems] = useState<CheckResultArtefact[]>([])
  const [downloadingId, setDownloadingId] = useState<string | null>(null)
  const { wait, loading } = useHttpLoader()

  useEffect(() => {
    if (!resultId) {
      setItems([])
      return
    }
    wait(inspectionApi.getCheckResultArtefacts(resultId), (resp) => {
      if (resp.status === 'success') {
        const list = Array.isArray(resp.body) ? resp.body : resp.body?.items ?? []
        setItems(list)
      }
    })
  }, [resultId])

  const handleDownload = useCallback(
    (e: React.MouseEvent, item: CheckResultArtefact) => {
      if (!item.file) return
      e.preventDefault()
      const url = item.file.url;
      setDownloadingId(item.id)
      http
        .get(url, { responseType: 'blob' })
        .then((res) => {
          const blob = res.data as Blob
          const blobUrl = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = item.file?.fileName ?? 'file'
          a.click()
          URL.revokeObjectURL(blobUrl)
        })
        .finally(() => setDownloadingId(null))
    },
    []
  )

  return (
    <Card type='normal'>
      <div className='flex-lines'>
        <div style={{ marginBottom: '16px' }}>
          <h2 className='text--caption-l text-700'>Ответы команды</h2>
        </div>
        {loading ? (
          <div className='text--body-m text--secondary'>Загрузка...</div>
        ) : (
          <div className='flex-lines' style={{ gap: '16px' }}>
            {items.length === 0 ? (
              <div className='text--body-m text--secondary'>Нет ответов</div>
            ) : (
              items.map((item) => (
                <TextField
                  key={item.id}
                  header={item.projectCheckpointExpectedArtefact?.title ?? 'Без названия'}
                >
                  {item.text ||
                    (item.file && (
                      <a
                        href={""}
                        onClick={(e) => handleDownload(e, item)}
                      >
                        {downloadingId === item.id ? 'Скачивание...' : item.file.fileName}
                      </a>
                    )) ||
                    '-'}
                </TextField>
              ))
            )}
          </div>
        )}
      </div>
    </Card>
  )
}

export default SubmissionTeamAnswersCard
